import { useEffect, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { SET_ACTIVE_TAB } from '../../redux/actions/main';
import Main from './fragments/Main'

const ClientChat = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch({ type: SET_ACTIVE_TAB, tab: '/chat-client' });
    }, []);

    return (
        <Fragment>
            <Main />
        </Fragment>
    )
}

export default ClientChat;